import type { ComponentType } from 'react';
import type { ProjectType } from '../../core/types/data-models';
import { IdeaValidationWizard } from './idea-validation/IdeaValidationWizard';
import { BusinessValidationWizard } from './business-validation/BusinessValidationWizard';
import { StockValidationWizard } from './stock-validation/StockValidationWizard';

export interface OnboardingRoute {
  slug: string;
  projectType: ProjectType;
  /** Absent while that type's wizard is not built yet — the picker shows the card as "coming soon". */
  Wizard?: ComponentType;
}

export const ONBOARDING_PATH = '/onboarding';

/**
 * slug ↔ ProjectType and slug → wizard component. The slugs are public: the
 * website's "Get Started" buttons link to `/onboarding/<slug>`, so change
 * them together.
 */
export const ONBOARDING_ROUTES: OnboardingRoute[] = [
  { slug: 'idea-validation', projectType: 'IDEA_VALIDATION', Wizard: IdeaValidationWizard },
  { slug: 'business-validation', projectType: 'BUSINESS_VALIDATION', Wizard: BusinessValidationWizard },
  { slug: 'stock-validation', projectType: 'STOCK_VALIDATION', Wizard: StockValidationWizard },
  { slug: 'strategy-management', projectType: 'STRATEGY_MANAGEMENT' },
];

export function findOnboardingRoute(slug: string | undefined): OnboardingRoute | undefined {
  return ONBOARDING_ROUTES.find((r) => r.slug === slug);
}

export function onboardingRouteFor(projectType: ProjectType): OnboardingRoute | undefined {
  return ONBOARDING_ROUTES.find((r) => r.projectType === projectType);
}
